import React from 'react';
import { Target, TrendingUp, Shield, Wrench } from 'lucide-react';
export function MethodSection() {
  const features = [{
    icon: <Target className="w-10 h-10 text-[#D4AF37]" data-id="element-154" />,
    title: 'Paso a Paso Claro',
    description: 'Sin relleno. Directo a lo que funciona para que aprendas rápido y bien.'
  }, {
    icon: <Shield className="w-10 h-10 text-[#D4AF37]" data-id="element-155" />,
    title: 'Cero Riesgos',
    description: 'Aprenderás las técnicas seguras para nunca dañar la pintura de un vehículo.'
  }, {
    icon: <TrendingUp className="w-10 h-10 text-[#D4AF37]" data-id="element-156" />,
    title: 'Enfoque en Negocios',
    description: 'No solo te enseñamos a limpiar, te enseñamos a cobrar y ganar dinero.'
  }, {
    icon: <Wrench className="w-10 h-10 text-[#D4AF37]" data-id="element-157" />,
    title: 'Herramientas Exactas',
    description: 'Sabrás exactamente qué comprar sin gastar de más en productos innecesarios.'
  }];
  return <section className="bg-[#0E1F3D] py-20 px-4" data-id="element-158">
      <div className="max-w-5xl mx-auto" data-id="element-159">
        <div className="text-center mb-16" data-id="element-160">
          <h2 className="text-4xl md:text-6xl font-black text-white mb-6 uppercase tracking-tight" data-id="element-161">
            Presentamos el sistema <br data-id="element-162" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#D4AF37] to-[#B8860B]" data-id="element-163">
              MÉTODO DETAILING PRO
            </span>
          </h2>
          <div className="w-24 h-2 bg-[#D4AF37] mx-auto mb-8" data-id="element-164"></div>
          <p className="text-xl md:text-2xl text-gray-300 font-medium max-w-3xl mx-auto leading-relaxed" data-id="element-165">
            Un entrenamiento paso a paso diseñado específicamente para ayudar a
            principiantes a aprender detailing de forma profesional y empezar a
            generar ingresos reales.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-166">
          {features.map((feature, index) => <div key={index} className="bg-[#132847] p-8 rounded-2xl border border-[#1E3A5F] hover:border-[#D4AF37] hover:shadow-lg hover:shadow-[#D4AF37]/10 transition-all duration-300 group" data-id="element-167">
              <div className="bg-[#0A1628] w-20 h-20 rounded-full flex items-center justify-center shadow-md mb-6 group-hover:scale-110 transition-transform border border-[#1E3A5F]" data-id="element-168">
                {feature.icon}
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-169">
                {feature.title}
              </h3>
              <p className="text-gray-400 text-lg leading-relaxed" data-id="element-170">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}